import React from 'react';
import { Image } from 'UI';

export const TireBackground = (): JSX.Element => <Image src="tires/tire.jpg" height={160} alt="tire" />;
